import { useState, useRef, useEffect, RefObject, Dispatch, SetStateAction } from 'react';
import { getEdgeArrowPosition } from './helpers';

export const useReactionMenu = () => {
  const [reactionCoordinates, setReactionCoordinates] = useState<{ x: number; y: number } | null>(null);
  const [isQuickReactionOpen, setIsQuickReactionOpen] = useState(false);
  const [isReactionsModalOpen, setIsReactionsModalOpen] = useState(false);
  const infoRef = useRef<HTMLDivElement>(null);
  const [minusTop] = useState(0);

  // Add a unique identifier for this hook instance
  const instanceId = useRef(Math.random().toString(36).substr(2, 9));

  // Wrapper to track when setIsReactionsModalOpen is called
  const setReactionsModalOpen: Dispatch<SetStateAction<boolean>> = (value) => {
    const newValue = typeof value === 'function' ? value(isReactionsModalOpen) : value;
    setIsReactionsModalOpen(newValue);
  };

  return {
    reactionCoordinates,
    setReactionCoordinates,
    isQuickReactionOpen,
    setIsQuickReactionOpen,
    isReactionsModalOpen,
    setIsReactionsModalOpen: setReactionsModalOpen, // Use the wrapped function
    infoRef,
    minusTop,
    instanceId: instanceId.current, // Export for debugging
  };
};

export const useTooltipArrowCorrection = (isOpen: boolean): RefObject<HTMLDivElement> => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setTimeout(() => {
      const arrow: HTMLDivElement | null | undefined = ref.current?.querySelector('.react-tooltip-arrow');

      if (arrow) {
        const { left } = window.getComputedStyle(arrow);

        arrow.style.left = getEdgeArrowPosition(left);
      }
    }, 50);
  }, [isOpen]);

  return ref;
};
